
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* College Physics for AP Courses 2e */ 'fc65697b-5a9e-4dfe-ac03-035129f7be28': [
    /* College Physics 2e */ ['a31df062-930a-4f46-8953-605711e6d204', {}],
  ],
  /* College Physics for AP Courses 1e */ '8d04a686-d5e8-4798-a27d-c608e4d0e187': [
    /* College Physics for AP Courses 2e */ ['fc65697b-5a9e-4dfe-ac03-035129f7be28', {
      /* Physics: An Introduction to the same module in 2e */
      '2f8a5d38-00d5-4c53-8df5-01294fb5a764': '39256206-03b0-4396-abb6-75e6ee5e3c7b',
      /* Physical Quantities and Units to the same module in 2e */
      '090879ad-ff66-47ff-b53c-ebf01ac71074': '102e9604-daa7-4a09-9f9e-232251d1a4ee',
      /* Accuracy, Precision, and Significant Figures to the same module in 2e */
      '5ee69368-0ea2-4e36-9e51-b7b7512fb3af': '4bba6a1c-a0e6-45c0-988c-0d5c23425670',
      /* Approximation to the same module in 2e */
      '9f99d708-757e-4a21-9bc7-4d92952d1630': 'eb75b532-91ca-4c3d-b803-db329981914a',
      /* Displacement to the same module in 2e */
      '72169e9d-cba1-4d43-923c-41ae4d01b3cc': 'fc7dc488-f4ec-498c-b261-3b75eaa70aaa',
      /* Vectors, Scalars, and Coordinate Systems to the same module in 2e */
      '9b8ecf49-1d96-4a5a-b7c7-ab3f42b98683': '823f4a1e-3d10-44b6-a22e-8608f72c6eca',
      /* Time, Velocity, and Speed to the same module in 2e */
      'f6a98016-c865-4380-aea5-eb6578481242': '15a9679c-0422-4712-9a6e-71bad4472a0c',
      /* Acceleration to the same module in 2e */
      '56871db7-51e9-4504-94d0-9cb833851945': '6023b87d-5a28-4910-9e51-ee7fd11c98e1',
      /* Motion Equations for Constant Acceleration in One Dimension to the same module in 2e */
      '24cdc32e-2fde-4a12-b758-2728ed223758': 'ea2bb23c-4fce-4e9d-a46b-3754125da988',
      /* Problem-Solving Basics for One-Dimensional Kinematics to the same module in 2e */
      '34cee680-d73d-40b1-99aa-db0f8bfbf28d': '68db177b-ab5c-48b9-8bcc-721e140fed8b',
      /* Falling Objects to the same module in 2e */
      '34176c43-5a3b-4e21-950d-3b724e819b15': '9e486db8-120e-4507-b265-e5248007faba',
      /* Graphical Analysis of One-Dimensional Motion to the same module in 2e */
      '20986bfa-2c2a-47f1-a48a-786122b0c606': 'ef1e90b2-9c2d-4d35-9faa-d1055b8d89db',
      /* Kinematics in Two Dimensions: An Introduction to the same module in 2e */
      '137a5bbf-0ef3-4026-aa78-f61eb3ec87c2': '21d0e217-d50f-4901-af75-905e738eb4c4',
      /* Vector Addition and Subtraction: Graphical Methods to the same module in 2e */
      '5b264795-329f-44e0-8972-0133f0c98af0': '4bd8bbec-bda2-412b-96f8-cc0b7ff5e794',
      /* Vector Addition and Subtraction: Analytical Methods to the same module in 2e */
      'b7a2885d-9d3c-4e64-b382-b1da2b70d587': 'b9739bfd-dc9d-4f0a-b037-dc22884d30f3',
      /* Projectile Motion to the same module in 2e */
      'b46567e9-4987-49f5-ba7c-828a756c372c': '69062f44-56d2-4111-88ff-f599727c4ed1',
      /* Addition of Velocities to the same module in 2e */
      'bd6954c0-bca9-4d5b-9e88-efc46164aac5': 'b64da007-2df2-4425-8f4b-e4d42ed423d9',
      /* Development of Force Concept to the same module in 2e */
      '708c252a-d832-48ab-9d66-06590e607b89': 'de43ae15-d1fa-4265-98f6-9820ff31a270',
      /* Newton’s First Law of Motion: Inertia to the same module in 2e */
      'abae927d-b545-4981-8e47-602c3fcb6ce5': 'e4084c4d-df8b-43d3-af14-c2ea68d59f92',
      /* Newton’s Second Law of Motion: Concept of a System to the same module in 2e */
      'ddb573f3-3ef8-4bc7-8169-2bf9c35b7bad': '8afa5bc0-8fb5-4d10-bddc-e626afef65ee',
      /* Newton’s Third Law of Motion: Symmetry in Forces to the same module in 2e */
      '688e78df-9130-45bb-a6e5-9ddca5204ed7': 'd5510a8b-a06e-4634-a63f-2ec97b293af6',
      /* Normal, Tension, and Other Examples of Forces to the same module in 2e */
      '7b751b5e-3f12-48f3-9c23-5add811fccd6': '5a51b5c5-1756-4d6c-b9be-84a9627ef003',
      /* Problem-Solving Strategies to the same module in 2e */
      'c9e804f3-002b-409f-8b2a-e2d67872a455': '994814cc-52e2-4398-9a96-eae02025519e',
      /* Further Applications of Newton’s Laws of Motion to the same module in 2e */
      'c8839816-3545-4281-8551-2eeee05afa78': 'c372561e-08e8-41a1-ba72-9b4c00394c2d',
      /* Extended Topic: The Four Basic Forces—An Introduction to the same module in 2e */
      'af7d5528-af37-4845-a509-85a0a4b75a79': 'c874ccd3-6c58-4104-918e-bded4f2c9ea4',
      /* Friction to the same module in 2e */
      'bda8a7a1-c582-428a-8cb8-c2d200624ed7': '7bf5b534-4196-4484-a777-a2f636a4cc11',
      /* Drag Forces to the same module in 2e */
      '477b5ef5-5b9a-42f5-bc3f-399ba6819ec3': 'be308439-f9b1-40e7-b0a6-1631cbc7feaa',
      /* Elasticity: Stress and Strain to the same module in 2e */
      '90cc17be-4018-4033-8435-2a38365bb041': 'f11ae42f-9666-4f36-93d9-0093f94df061',
      /* Rotation Angle and Angular Velocity to the same module in 2e */
      '33836eec-f196-4963-a304-2949346b26d4': '44216d83-fe7e-461d-a5f4-9f3e2ffa284b',
      /* Centripetal Acceleration to the same module in 2e */
      '67e1ef42-16bb-45e4-b3ea-40a8d856e14e': '96c50bd3-3f5f-42f6-8812-f3494e0f0888',
      /* Centripetal Force to the same module in 2e */
      '9acd67ba-70e9-4cb5-b2b2-f985e060d1f9': '584a0fe8-56d0-497c-8f3d-8b0e3f0359a1',
      /* Fictitious Forces and Non-inertial Frames: The Coriolis Force to the same module in 2e */
      '6fc611ce-ed32-4456-b24c-39612ebc9304': '86cc09b6-80c6-43ad-b80f-187571f45107',
      /* Newton’s Universal Law of Gravitation to the same module in 2e */
      '38cc5fae-340b-4ce3-b2ed-847ff2bd2d5f': 'df3cd28b-1aba-4abc-84d7-54224fbd2a78',
      /* Satellites and Kepler’s Laws: An Argument for Simplicity to the same module in 2e */
      '26a7134e-b428-46a7-97e2-3a06ca43222f': '4a4407ed-0969-4018-806f-6ea728d6efb4',
      /* Work: The Scientific Definition to the same module in 2e */
      'b41a6a7a-5fa2-4400-b07e-a507e0529003': '364a282d-6278-46df-83c1-1df19d673b51',
      /* Kinetic Energy and the Work-Energy Theorem to the same module in 2e */
      '5035aeb8-8f6d-46e7-9552-55d5ea593368': '3fffbab5-5b0d-4622-be83-eb65111f9c3e',
      /* Gravitational Potential Energy to the same module in 2e */
      'bed9d7b4-bebb-4937-8b3d-14b166280017': '453c581f-c03a-4594-b17f-28f97fa6d39e',
      /* Conservative Forces and Potential Energy to the same module in 2e */
      '383e8423-1b6b-4a7d-8ced-39e7baaf235e': '32fa5f4a-677f-455a-b767-8711ee4bf7a8',
      /* Nonconservative Forces to the same module in 2e */
      '73d1aa00-c51e-4940-83b0-e83d4d2b6850': '092ffa28-a19e-4bd7-939a-1dfef1ee2a1a',
      /* Conservation of Energy to the same module in 2e */
      '3775240a-ff7a-48fa-822a-b460630a3055': 'c5adb012-fbab-41a7-b5b2-4644984097fc',
      /* Power to the same module in 2e */
      '57712284-c5a2-494a-9f67-ffba466f5d13': 'c82515ee-02ef-4e15-9b4f-52e67617359c',
      /* Work, Energy, and Power in Humans to the same module in 2e */
      '29c6c8f4-75a5-4f4c-bf2b-1d1e3b30fa5e': '6c62826b-e33c-446f-b8d0-10a4b6156549',
      /* World Energy Use to the same module in 2e */
      'b9fb585d-2ed0-4809-bb68-d2e403d15ac9': 'a4b7e0ec-bded-45de-8016-416aaaa8286b',
      /* Linear Momentum and Force to the same module in 2e */
      '5fe57a54-260a-40f1-a173-191fda3cb2e9': '93d34b53-54fb-4056-b8a5-ce22ec22321f',
      /* Impulse to the same module in 2e */
      'dfc8e07c-be70-45ca-8326-aa6a1b7d8395': '0b3a0e16-bd31-4349-af57-dcdacbfab7ce',
      /* Conservation of Momentum to the same module in 2e */
      '1e9b22ea-6f8e-4bf1-9d68-02c10a64faf8': '007123e0-9db4-48bf-bd90-8976ff53a920',
      /* Elastic Collisions in One Dimension to the same module in 2e */
      '0cdfe0ae-c1c9-4b0c-8b2c-b5c33308b63a': 'e9d1f538-7368-4465-ab33-94ba72cd1872',
      /* Inelastic Collisions in One Dimension to the same module in 2e */
      '41216643-c6fb-401e-bbb4-ece7fbbabf00': '9f4cace5-1963-43b0-bfca-2ab221ed2c7a',
      /* Collisions of Point Masses in Two Dimensions to the same module in 2e */
      'b047027d-647b-4942-ab91-9365a12a8944': 'ca0b6bf0-e249-45a5-aa43-3088b4f66739',
      /* Introduction to Rocket Propulsion to the same module in 2e */
      'ea04b5d5-aa31-4315-ae2a-2e83326dc0d0': '5ea664f4-f320-4873-93c7-0dc838e9c9ae',
      /* The First Condition for Equilibrium to the same module in 2e */
      '2a643ed4-747f-4fb5-a47c-83d81210c823': 'ee1ff255-2c04-4a6d-aa23-6d981b02ea48',
      /* The Second Condition for Equilibrium to the same module in 2e */
      '7af43edb-9762-4cb1-9e40-6a8e93e7917d': '11aac25a-551d-4c47-8524-1a98414470b3',
      /* Stability to the same module in 2e */
      'c1505a0e-a9a3-413a-a1e1-ee34b19f44b7': 'be842fb1-f9fc-48db-919b-b197c7a6ee8c',
      /* Applications of Statics, Including Problem-Solving Strategies to the same module in 2e */
      '815c37d8-b5ed-4596-ae2b-f96d5fbbd42b': 'd3c30b71-3b67-41b1-9e1e-5accd05f159d',
      /* Simple Machines to the same module in 2e */
      '9d32a762-df87-4ff4-8c5a-eea9f44f63d7': 'bdb0d66d-b9f2-4143-80f8-f07a066bb6ff',
      /* Forces and Torques in Muscles and Joints to the same module in 2e */
      'daa777f5-2c12-46ed-a434-73c5eea02272': 'd703853c-6382-4035-8d6a-dcbca00a15ca',
      /* Angular Acceleration to the same module in 2e */
      '6ecfc9f8-e79b-456b-9435-62b0f04f9222': '094852a0-7f89-4a97-b8ea-5659133fd740',
      /* Kinematics of Rotational Motion to the same module in 2e */
      'c4ebfd25-2630-4920-a094-75b9d68e278f': '1f067ea8-6cbe-463b-b672-8cd39ccfb360',
      /* Dynamics of Rotational Motion: Rotational Inertia to the same module in 2e */
      '0857d897-d418-456a-bb95-4263bfc4f956': 'db59f656-e708-4094-a742-1e5560fe97c9',
      /* Rotational Kinetic Energy: Work and Energy Revisited to the same module in 2e */
      'c83180f8-21d8-489d-b340-d65b330981cc': 'b328b5a2-79ea-4faa-9674-8d62df2f288e',
      /* Angular Momentum and Its Conservation to the same module in 2e */
      '6d262364-bbc3-4395-bf70-b0082377937e': '7de5be93-09e1-4ab6-8282-bec00a3e9f3d',
      /* Collisions of Extended Bodies in Two Dimensions to the same module in 2e */
      '02c6e7b2-1614-4fc3-a850-4381bef8ba91': '9b497f46-c979-43cd-a431-be855ec76d47',
      /* Gyroscopic Effects: Vector Aspects of Angular Momentum to the same module in 2e */
      '63f3b6cc-8d16-49e8-af45-2e5304851f88': '041effb0-5b88-46e0-895e-4b9f804607df',
      /* What Is a Fluid? to the same module in 2e */
      '71b5afe1-d25a-467b-8832-0b63917b542b': 'bb9825e1-092e-4c11-b5c8-265d4317ae34',
      /* Density to the same module in 2e */
      '39721707-2aad-419c-97e6-91c5a615e6fd': 'f137588f-b7a9-44cd-8df1-1818df41d568',
      /* Pressure to the same module in 2e */
      '3c11319b-f7cb-40af-a206-d52b4ca5f3b6': 'f713bda9-67f7-49c9-9d9d-ca2e34a202a5',
      /* Variation of Pressure with Depth in a Fluid to the same module in 2e */
      'ba447b72-11a6-4e2d-83ca-652732015184': '5f0b0e0e-e825-4aeb-9c8e-1f64a6942233',
      /* Pascal’s Principle to the same module in 2e */
      '7d2fffd4-1e38-4d87-80d0-debb5b713e63': 'e980d635-5f4c-4857-9b29-c51ee0760909',
      /* Gauge Pressure, Absolute Pressure, and Pressure Measurement to the same module in 2e */
      '784ab68b-d988-4591-99a9-1cbd0ffe0d9d': 'a08ff613-3d40-4b34-8416-782febd89317',
      /* Archimedes’ Principle to the same module in 2e */
      'b682fa00-0e5d-42d4-a08b-f59a19cbcf47': '81e232b0-5245-4d19-b28d-31c1cf1624e0',
      /* Cohesion and Adhesion in Liquids: Surface Tension and Capillary Action to the same module in 2e */
      'eaed3e23-3016-4cb0-936e-7158b633cba2': 'eef12ab9-588f-4922-9314-ac1cb25831f5',
      /* Pressures in the Body to the same module in 2e */
      '7cb980be-1e22-43a1-9e15-6c7d5a88f1bf': '156f6f78-a4e7-454d-a032-9b14f4223cd9',
      /* Flow Rate and Its Relation to Velocity to the same module in 2e */
      '18c425b0-5b7d-4459-824d-fa3865a85f33': '83d270f5-baa0-4bf9-a22a-539025b29180',
      /* Bernoulli’s Equation to the same module in 2e */
      '2cbc5950-ef18-459c-9bb5-ad07ae099b96': '0c8ac66c-a41b-4861-8fc6-e9633182091f',
      /* The Most General Applications of Bernoulli’s Equation to the same module in 2e */
      '3cc9dad4-fa9e-48e6-9c73-b809e0fa6ebc': 'fcfe29e0-3fcf-4f9a-a269-51b8bb710f2f',
      /* Viscosity and Laminar Flow; Poiseuille’s Law to the same module in 2e */
      'd289d85f-5322-45e4-b511-ebe2af877f5a': 'a4293fc2-4de2-4506-b890-a7abdeb70c16',
      /* The Onset of Turbulence to the same module in 2e */
      'f9bcec50-b383-4699-bccf-0376f51baa46': '6e2ab67b-2c38-4d06-8ec7-648e083b628e',
      /* Motion of an Object in a Viscous Fluid to the same module in 2e */
      '23490429-61d8-43ea-9e1f-d66a51b39786': '1351c941-c9c6-416a-be45-12c6a072301e',
      /* Molecular Transport Phenomena: Diffusion, Osmosis, and Related Processes to the same module in 2e */
      'b98a36ec-4764-40ff-a8cf-ac09b90c397f': 'd1dec991-380c-4534-a394-14e5a7729872',
      /* Temperature to the same module in 2e */
      '755b8a47-c7b5-4909-a302-81c9c05568a3': 'da8bb426-0db2-44a0-8a48-a62c2acf4482',
      /* Thermal Expansion of Solids and Liquids to the same module in 2e */
      'a6d4eef5-a21e-47e5-8c17-e855d11267ba': '0b6d0d23-e96f-4f34-8051-643361f8c7c7',
      /* The Ideal Gas Law to the same module in 2e */
      '48fbbdd1-186c-4add-8b1e-44dabbf7c870': '8f4cb076-9f5f-4a21-966e-079d768f7a98',
      /* Kinetic Theory: Atomic and Molecular Explanation of Pressure and Temperature to the same module in 2e */
      '954f3359-ec30-425c-962f-0d325de314f1': 'bb091009-f21f-47a2-954b-3b79871974b3',
      /* Phase Changes to the same module in 2e */
      '2fe0af4d-3792-495d-9178-633886099f91': 'a12ace0a-4c9f-4297-bc76-1c3b77d4d9ce',
      /* Humidity, Evaporation, and Boiling to the same module in 2e */
      '8c8eb589-e4b7-4a9d-b77e-29f6a219484c': '030347e9-f128-486f-a779-019ac474ff90',
      /* Heat to the same module in 2e */
      '67ac5679-be66-46a0-a787-286c431316c7': '5175e6a6-f84b-4955-9840-c9f07e8e7436',
      /* Temperature Change and Heat Capacity to the same module in 2e */
      '294d57ce-ebde-40fd-a751-c133630e1d45': '5c0d1577-c0dc-43c0-9c49-aca8e01227ff',
      /* Phase Change and Latent Heat to the same module in 2e */
      '4d3f6546-9e54-4a2c-ba76-671a8c427f5c': '5f2b5aef-4948-488f-8ff9-839478a6d6cf',
      /* Heat Transfer Methods to the same module in 2e */
      'f76fb812-b598-42d2-89fc-ca3c2fa35fe9': '43516708-07b1-48f9-8314-7460d6ce7bbb',
      /* Conduction to the same module in 2e */
      '99c16b2f-7658-49ee-81a3-97850593f521': 'a7beda43-2f3a-4d12-adfe-2e19c20b5e14',
      /* Convection to the same module in 2e */
      'c9ceb764-767c-4186-a72b-4ea56698098a': 'abc2bcc9-2003-4d36-971a-05781d15e99c',
      /* Radiation to the same module in 2e */
      '5b06da7e-d17c-4438-a5eb-bfbcb5a8e57c': '949ae786-a308-4f86-be47-32358239ac40',
      /* The First Law of Thermodynamics to the same module in 2e */
      '2499fe6d-41be-4e32-83b0-d93bf558ae47': 'fb11b483-b85f-4cda-bec7-4dfd136dba60',
      /* The First Law of Thermodynamics and Some Simple Processes to the same module in 2e */
      'd25883e8-2a6b-4afa-9f40-46f116461546': 'c54309db-5b78-4a77-9e4f-61adc778cb50',
      /* Introduction to the Second Law of Thermodynamics: Heat Engines and Their Efficiency to the same module in 2e */
      '03a8500e-2942-4b15-803b-525dd9e05192': 'c54309db-5b78-4a77-9e4f-61adc778cb50',
      /* Carnot’s Perfect Heat Engine: The Second Law of Thermodynamics Restated to the same module in 2e */
      'ef31c190-ad81-4f8f-828b-352b66f81000': '2f8e92ba-f6a4-4fae-9228-64fd959894d8',
      /* Applications of Thermodynamics: Heat Pumps and Refrigerators to the same module in 2e */
      '0809d78f-814d-4ff2-b77b-a47a476ce004': '2f328efd-976e-4d46-9a43-abbcb8f8bbb1',
      /* Entropy and the Second Law of Thermodynamics: Disorder and the Unavailability of Energy to the same module in 2e */
      'aa686082-7758-420b-81db-b76436e6456a': '15a50194-9cf1-4848-8d68-dcce5788433e',
      /* Statistical Interpretation of Entropy and the Second Law of Thermodynamics: The Underlying Explanation to the same module in 2e */
      '49ecea37-06be-48bb-b87c-2c442efa62bb': 'd9b9681a-d5d8-4640-91bd-68268ccebf33',
      /* Hooke’s Law: Stress and Strain Revisited to the same module in 2e */
      '7607d20d-e471-4bea-8487-1092b5451930': 'a7c21260-3cf9-49cc-91f7-b631fa0c5d42',
      /* Period and Frequency in Oscillations to the same module in 2e */
      '5a95780f-9ba4-4d27-a7ec-690a042864cb': '33575669-8638-45a8-b8cf-17b64b35e071',
      /* Simple Harmonic Motion: A Special Periodic Motion to the same module in 2e */
      'c2680b92-cd9d-4395-9a63-fdca13379b71': '2a1ffd48-03ba-45d0-94bc-8afc38ebad19',
      /* The Simple Pendulum to the same module in 2e */
      '140ef9c3-f649-46c8-b7d6-d269231096c6': '1b81c792-239f-4107-9e94-37233e6f7e92',
      /* Energy and the Simple Harmonic Oscillator to the same module in 2e */
      '111ed811-2f99-45ee-9a37-8a1a92ac2c7e': '85b8cd63-e27c-456e-a04f-2312e3966efc',
      /* Uniform Circular Motion and Simple Harmonic Motion to the same module in 2e */
      '8e7bbf1d-d332-4812-89b8-c4b86356d060': 'cd0534f2-ecfb-4784-8db6-c93aad2f8e36',
      /* Damped Harmonic Motion to the same module in 2e */
      '654153d7-fe63-40cd-9ff6-89b9ecde2198': '667fb406-3de7-4ecd-93f5-aedd38351567',
      /* Forced Oscillations and Resonance to the same module in 2e */
      'e5ef8fb5-71f4-45a7-a32f-1ac0af202612': '51dcd05d-d69a-4107-8193-f3e95cd96ef1',
      /* Waves to the same module in 2e */
      'd57f8140-9072-40fb-abbb-4f1ded13bdcf': 'ea610ab5-6698-4f16-b4f1-6a210247701f',
      /* Superposition and Interference to the same module in 2e */
      '42ac8683-b84b-4cd8-a84d-1b5670404cf1': 'f1b5b000-de07-4a0e-9078-4620a3bc7c34',
      /* Energy in Waves: Intensity to the same module in 2e */
      '65dbd8e0-2563-4ca3-9387-873076d92ef5': 'c1cfa73e-8b38-431c-af6e-ecba8c1fee70',
      /* Sound to the same module in 2e */
      'cd60ca75-63b0-4b28-8e10-a374eebfc382': '9d20f102-8c97-4cd1-a16e-b7d5dce1a076',
      /* Speed of Sound, Frequency, and Wavelength to the same module in 2e */
      '177f95a9-8db4-4ede-a8e9-1838cc34e42d': 'c840334f-0189-48ae-80db-a9afafa72b73',
      /* Sound Intensity and Sound Level to the same module in 2e */
      'a2e1a3a2-c3e5-41ba-9d29-62320ab4822e': '6205f327-1b6e-4bbe-a4b2-f6d0b5df29d5',
      /* Doppler Effect and Sonic Booms to the same module in 2e */
      'ad694f2e-8fcc-4a8b-8c68-3e5190ef41fb': '37891e98-ce8b-4a6a-8e5e-d9889126d53a',
      /* Sound Interference and Resonance: Standing Waves in Air Columns to the same module in 2e */
      '57c669ea-5957-41c2-8d2c-c667c8ae4441': 'e4c1bfff-3e91-4254-a5f7-0e4582a0541f',
      /* Hearing to the same module in 2e */
      '2b48d397-f793-4ac7-845b-a99ddc4a0a4e': 'cef0ea3c-00aa-4755-a6e5-92ffec01dc60',
      /* Ultrasound to the same module in 2e */
      'e00b2ee5-7224-49cf-9455-0446c88549d7': '1cd25156-7b13-4767-a14d-71ad2ce0352d',
      /* Static Electricity and Charge: Conservation of Charge to the same module in 2e */
      '2993cae4-b418-40e2-9d1f-df151d425d7e': 'bb7dc37b-5a71-4f4d-b83f-524e0f1b3c74',
      /* Conductors and Insulators to the same module in 2e */
      'f38cba79-e8c0-454c-908d-11804b749048': 'f2f59eb2-3373-4243-85f7-03c5e71a4258',
      /* Coulomb’s Law to the same module in 2e */
      '0aa94add-1dca-4d25-a4e0-ffd782bcbae7': 'e3e62326-ebb7-4810-a202-e4e690745b76',
      /* Electric Field: Concept of a Field Revisited to the same module in 2e */
      'bcdc3467-bd9f-4c74-bc7f-af17af26e973': 'db918015-7645-42cf-8bf7-64d09ad7b838',
      /* Electric Field Lines: Multiple Charges to the same module in 2e */
      '846151fd-2e4a-4f57-8cb8-0ad2567a440c': '6f4d1b30-1c7e-440d-bcb4-26f1ffebe4d3',
      /* Electric Forces in Biology to the same module in 2e */
      '1a97341f-b942-4565-91a9-851e82e8b18d': '27262a1a-c710-4f5e-8d84-d2d962a23f8b',
      /* Conductors and Electric Fields in Static Equilibrium to the same module in 2e */
      '9ea5f117-7c41-4bc2-bf50-741dc18d36c6': '6bcb560d-d0eb-4c91-9ac0-5ef46b68fd05',
      /* Applications of Electrostatics to the same module in 2e */
      '855e6cec-0221-4e2a-94f6-22ca37afca39': '56ae5355-400b-4330-8552-980b0744e2ca',
      /* Electric Potential Energy: Potential Difference to the same module in 2e */
      'ba225bb5-bd8a-4dbd-abed-defab101525b': '650c4bb3-d190-44fd-9f2f-445a783abdec',
      /* Electric Potential in a Uniform Electric Field to the same module in 2e */
      '7e5d5dca-d068-4d1d-b8f5-a0016c9cd885': 'c793cc2b-c0ab-4089-a452-677700c3f9ac',
      /* Electrical Potential Due to a Point Charge to the same module in 2e */
      '4a7e386f-9038-48f2-ad67-00df5314ded7': '2853d33b-313d-47bf-8658-12eecf8cf548',
      /* Equipotential Lines to the same module in 2e */
      '23e00a1f-1f10-4fdb-bb58-a065511b2a5c': '038b3dc5-0d7f-451b-aac0-94d4bd413b45',
      /* Capacitors and Dielectrics to the same module in 2e */
      '3e23d0f1-22c7-47a2-8185-c9a9fc23a9fd': '56d8ca48-ab11-477d-b800-31b812b036b2',
      /* Capacitors in Series and Parallel to the same module in 2e */
      '124bae73-08de-47e9-b29e-93a4c497c619': 'f090675d-b0b4-4194-a4f0-084980010b4a',
      /* Energy Stored in Capacitors to the same module in 2e */
      '8501974c-e17f-4c54-a217-ce9d2273ddf3': '7429b93d-106e-417e-b01f-a68c04312d93',
      /* Current to the same module in 2e */
      'fde7ad33-0064-4c3f-beb2-fdc32faad777': 'ddcb78bf-7739-4aea-abd2-ab6c07a16bf4',
      /* Ohm’s Law: Resistance and Simple Circuits to the same module in 2e */
      'cfb4cad4-0093-451c-82ed-f59c28b9ff24': 'c8b9a2f8-cb8f-484f-b53c-72459218c189',
      /* Resistance and Resistivity to the same module in 2e */
      'c06be26c-5245-4a57-8ed0-ec8f2a5c32e7': 'a5e2058d-3bf0-4538-9e0d-d72e24a9acfd',
      /* Electric Power and Energy to the same module in 2e */
      '7bd61dab-ae59-4a3b-a5b7-99be12a6f7d8': '449b1cf7-592e-4625-8269-280bfa10d7ec',
      /* Alternating Current versus Direct Current to the same module in 2e */
      'e8869a42-f03e-4c17-a714-34d0be38ada8': '202dd999-9170-4370-9c0c-61055833077d',
      /* Electric Hazards and the Human Body to the same module in 2e */
      '278a1d73-88dd-4654-a475-5d9730025528': '3facf881-302a-49af-bab8-60c569ecf7e5',
      /* Nerve Conduction–Electrocardiograms to the same module in 2e */
      '476c1665-9819-41c2-935f-9bfa02eb84b4': '41f56aa9-90a8-4c05-95d7-2608497844bf',
      /* Resistors in Series and Parallel to the same module in 2e */
      '953ede56-7b47-4756-80ed-3d8f5df13bc7': '14ba80ad-f75c-4bdf-900e-b8c8ef4e4057',
      /* Electromotive Force: Terminal Voltage to the same module in 2e */
      'db8dc238-ed36-45da-8983-eacc031493aa': '70fce0a0-0b57-44f4-9e0f-41e9cb5d862c',
      /* Kirchhoff’s Rules to the same module in 2e */
      'e52ffa90-8dae-47d8-8967-abd8827ce7b4': 'b4ee3784-8339-4649-8341-5a9b2f3d1624',
      /* DC Voltmeters and Ammeters to the same module in 2e */
      'd1d549df-ef92-4588-929b-669fbe802885': '43b351e5-230d-4ad8-b8df-1b3b02cf82cc',
      /* Null Measurements to the same module in 2e */
      '54ada5c2-fff6-49b8-ab7f-8c0e779e4ff2': '38b4afc9-d018-45b5-8873-1e9e0b1cd617',
      /* DC Circuits Containing Resistors and Capacitors to the same module in 2e */
      'cb71dd2f-1f0d-4737-8d4c-acd28ae9189a': '/bfd0e211-1e81-491b-a2e4-98942d2966f8',
      /* Magnets to the same module in 2e */
      'ebbd4827-46f5-4e8f-82e9-5b8c44325738': '7e9db09b-5b26-42c7-b575-e54edb48ad24',
      /* Ferromagnets and Electromagnets to the same module in 2e */
      '8f4e4958-fbf1-49ff-9dec-495cf4269446': '51c5169a-7d39-4279-9baa-625410c2546f',
      /* Magnetic Fields and Magnetic Field Lines to the same module in 2e */
      '3c462fff-87e8-49fa-8cef-3697efe55cb5': '38646924-2ca2-4da3-bfb7-1085797f79db',
      /* Magnetic Field Strength: Force on a Moving Charge in a Magnetic Field to the same module in 2e */
      '250e8d73-7869-408b-a2c6-74235b1ae313': '59d52989-6db1-42f9-83f9-6d9b29c901e7',
      /* Force on a Moving Charge in a Magnetic Field: Examples and Applications to the same module in 2e */
      'b264d1dd-daa6-4739-a28f-e3d6b33b0539': 'a66a7a2a-4d91-4887-8c5f-3757971a23b5',
      /* The Hall Effect to the same module in 2e */
      'dbe1cbe6-3b20-4266-a2bb-c13fdb34cb40': 'f048f400-4388-4969-b72b-c861f572e72f',
      /* Magnetic Force on a Current-Carrying Conductor to the same module in 2e */
      '9dc1851c-b523-4b27-8daf-f4ba7b802fd0': 'dc790996-7361-4ce2-be86-fc5b26b1a101',
      /* Torque on a Current Loop: Motors and Meters to the same module in 2e */
      'e981d2cc-335a-442b-93c6-fba91664ffd8': 'b37764d1-3493-40de-a222-13f8b9e78b67',
      /* Magnetic Fields Produced by Currents: Ampere’s Law to the same module in 2e */
      '55868b6f-8a0b-4ad0-a3a3-f8b12c6c2f52': 'cd08d0d3-2757-47cb-b34b-d92f87e5992c',
      /* Magnetic Force between Two Parallel Conductors to the same module in 2e */
      'aef280b2-5c8b-4d5b-994a-30ff0ea1adb6': 'af9c25bf-4412-44c4-aadd-39450a5aa757',
      /* More Applications of Magnetism to the same module in 2e */
      'fa29e310-73bd-4780-ba97-969d022e4864': 'c41454d9-4210-45be-8ead-afaf3f5d80a8',
      /* Induced Emf and Magnetic Flux to the same module in 2e */
      'b942de7c-92ac-4dab-85a3-0b09900a3f43': 'b1e5d043-94b4-4741-a738-e5bf547b76de',
      /* Faraday’s Law of Induction: Lenz’s Law to the same module in 2e */
      '371eb5e2-543f-425a-9c36-1042c342d326': 'c0672c45-1220-426e-b160-c859b879567d',
      /* Motional Emf to the same module in 2e */
      'ffb8e180-6baa-4895-9b93-dcd49f0939fb': 'bc843b81-d15d-4aa2-91ca-8ce8ea28df93',
      /* Eddy Currents and Magnetic Damping to the same module in 2e */
      '7b43b999-822e-4d31-99ba-d170160ffa4e': 'ff88cc31-4de8-4613-8001-0a421db11b04',
      /* Electric Generators to the same module in 2e */
      'be294f61-df75-4b3c-9c59-e2e5ab23c843': 'b60e7984-6740-4a1e-b202-f1ba0f263486',
      /* Back Emf to the same module in 2e */
      '913bfbac-8be8-4114-85b8-4a6f9e2858d6': 'e9e988ab-6940-444d-8879-b3cb9d3820eb',
      /* Transformers to the same module in 2e */
      'bc5c11a2-e098-41fa-b161-6eb1f50939ce': 'fe7dcf9b-c537-4574-b596-6ce8d33f240b',
      /* Electrical Safety: Systems and Devices to the same module in 2e */
      'd48302a3-136f-4fd2-a975-d61c7c993951': '8f205833-26b8-4eb4-98bb-936aad728cc6',
      /* Inductance to the same module in 2e */
      '4b0aefeb-38ef-49b7-b1fd-098f181b8495': '1520de70-3393-4fca-986e-e82658a6334b',
      /* RL Circuits to the same module in 2e */
      '2c302d46-4fa7-41f3-9b47-d1dbfa68ba7f': '786bafa0-52bf-499c-ad3f-5d44ef584e22',
      /* Reactance, Inductive and Capacitive to the same module in 2e */
      'e452d536-0093-4e5e-a5b2-e6f7ea75077f': '663b7dc1-df6f-4a85-bae8-10d20a358d01',
      /* RLC Series AC Circuits to the same module in 2e */
      '42db1410-23af-4f06-93b0-9dc93f795a57': '6bf1c4dd-f641-41b2-ac66-29e159880c03',
      /* Maxwell’s Equations: Electromagnetic Waves Predicted and Observed to the same module in 2e */
      'd9ac10a2-8fc7-42aa-8183-7db2025366a1': '0cf8d36f-d850-4354-af24-bd2b7c7281dc',
      /* Production of Electromagnetic Waves to the same module in 2e */
      'e0f8a596-486d-4ade-96ac-9859d131bac4': '47f5c05f-e68c-4218-9f5b-89e0b11d1e2d',
      /* The Electromagnetic Spectrum to the same module in 2e */
      'ef5e1e15-c223-42a3-9a37-81f583f1baef': 'f7dc8fa8-2f73-4018-9bbc-3c1c496d71bf',
      /* Energy in Electromagnetic Waves to the same module in 2e */
      '13da78bd-d948-431c-a9c6-c628f877e91a': '1f423843-0a03-4075-ba33-23fe18eaaaf4',
      /* The Ray Aspect of Light to the same module in 2e */
      'c6bda345-e7cb-4bd4-8746-00a7237b8f5d': '9ce5a3da-7400-44fe-86f2-1f75041dd48e',
      /* The Law of Reflection to the same module in 2e */
      '887a0746-dde7-4503-b376-fd07d8b68774': '60b4727b-829e-4ea7-9238-9140b6a1b20c',
      /* The Law of Refraction to the same module in 2e */
      'c5086d6f-9d82-4f7a-803e-66da7f5d568e': '18eef263-8513-4954-bcc8-07aa263f0a50',
      /* Total Internal Reflection to the same module in 2e */
      'd1df5bf8-e6f7-4e8c-a2af-8b3e8ff58e32': '00b1a523-3d56-49c4-bee1-dbb68cd25660',
      /* Dispersion: The Rainbow and Prisms to the same module in 2e */
      'e6bbfa83-1e4c-4ccb-be0f-53d7ed09c116': 'c221d1fc-6368-440d-9d75-00f45fc0570d',
      /* Image Formation by Lenses to the same module in 2e */
      'f80f9c39-57b2-454c-a285-ea8cfe81c81d': 'd977ddf6-69bf-46fd-8be6-5c41df45b092',
      /* Image Formation by Mirrors to the same module in 2e */
      'ed675322-fbca-4fda-a451-3ba66c1c95cc': '7254e46e-21b9-4466-81fe-a80923efa461',
      /* Physics of the Eye to the same module in 2e */
      'a8335f42-b69d-421e-89dd-6c61da89f598': '79d158aa-b426-4f73-b83a-f7d155c83478',
      /* Vision Correction to the same module in 2e */
      '49a4924b-2636-4410-9ed1-8e32262f5a6a': '2933fb66-6072-4b03-9cb6-7f2cad674638',
      /* Color and Color Vision to the same module in 2e */
      '9346f183-c6da-4c52-8232-187eaba6c024': 'd42c807d-a9fa-4e3d-83d0-0f7c745b51a0',
      /* Microscopes to the same module in 2e */
      'facd8c4c-5990-4840-8ab7-f69b0f27a241': '12b130cc-ca92-47de-8d58-ac28ba04b4fd',
      /* Telescopes to the same module in 2e */
      'd0f8cbe7-702f-452b-b81a-4074db9d7e50': '7083e2a6-93f2-4abd-8418-f363ebf0c224',
      /* Aberrations to the same module in 2e */
      'f83c074a-e93c-441e-aeed-cecfb5100b72': '699b651c-1400-46f0-9852-2cb4bb571693',
      /* The Wave Aspect of Light: Interference to the same module in 2e */
      'ed10ba90-8149-4e42-a617-c6e2708bccaa': 'd5bdc652-56a8-4d6d-9836-1b9474cff734',
      /* Huygens's Principle: Diffraction to the same module in 2e */
      '56a51025-965a-4b65-bb99-f6ba210c6b57': '95ca62ae-7363-4fab-9700-81d2e2e82fda',
      /* Young’s Double Slit Experiment to the same module in 2e */
      'e538a857-1730-441e-98c1-45207e2a2a05': 'c53f413f-75b6-44bd-b723-599d49a505fc',
      /* Multiple Slit Diffraction to the same module in 2e */
      '8b9cd656-1181-48e7-a9c3-30731b3b8e86': '86bcf046-c6db-4096-a9de-2e16ea076c84',
      /* Single Slit Diffraction to the same module in 2e */
      '2df6e31f-a0d8-4d5a-b354-a4547471b622': 'aac8ebd2-2db5-4b82-a4b2-4f2005643abe',
      /* Limits of Resolution: The Rayleigh Criterion to the same module in 2e */
      '43e882ac-d0e1-4368-a660-588459a65948': 'f403618a-c8e1-4b20-8737-6164df697aea',
      /* Thin Film Interference to the same module in 2e */
      '04a3f85c-7671-430b-adb4-1a48139fc5f7': '6cd5c4f3-f154-4617-912b-c12f47dd6429',
      /* Polarization to the same module in 2e */
      '96ce9bca-db83-4378-bd70-07eaee3e440a': '0119fe7d-4d1a-42de-b580-aa46659f8228',
      /* *Extended Topic* Microscopy Enhanced by the Wave Characteristics of Light to the same module in 2e */
      '2a25cadd-ac64-45fe-9a66-7bf5334c28a1': '0cc2b3c8-487e-49ea-925f-ff51cb2a0591',
      /* Einstein’s Postulates to the same module in 2e */
      '9c787d6e-6886-4098-a8cf-5dca13e9d470': '2617ad9f-6e56-4ebc-aba7-2236e3b07e46',
      /* Simultaneity And Time Dilation to the same module in 2e */
      '6494a307-cf30-4332-a45c-45b09e46a3a8': 'd6555a80-80d8-4829-9346-07ea9391f391',
      /* Length Contraction to the same module in 2e */
      'c28af67b-82ac-44cc-a2aa-b95e93d59f00': 'f2cf4758-0fdd-4c2c-ad7a-8814148ac022',
      /* Relativistic Addition of Velocities to the same module in 2e */
      '551e25de-e811-4162-8ff5-bdb7ac181276': 'e3a41220-af3f-40c6-b8ba-1a5d1bcbed92',
      /* Relativistic Momentum to the same module in 2e */
      'e04079fc-76e4-4a39-ac45-70a5ce6f8f85': 'cb474108-fe67-4904-bdbe-441b271ec10f',
      /* Relativistic Energy to the same module in 2e */
      'dd7f4e74-879d-470b-88ac-a1e28c0e7b48': '95b46f76-3199-4411-94ca-5318fff41746',
      /* Quantization of Energy to the same module in 2e */
      'cf5fb070-e0c7-4b8e-8241-c0b946450c78': 'c6ec1066-70a2-4971-b7ef-cd091877b264',
      /* The Photoelectric Effect to the same module in 2e */
      '73e6245b-c15b-4abb-8242-deb950cba2d0': 'c7deb632-6222-4c11-8ee8-45758b396ed3',
      /* Photon Energies and the Electromagnetic Spectrum to the same module in 2e */
      '3a247428-8d85-4d9d-9494-d8a75bc7bd66': '4df393d0-d550-4c64-bd52-bce4f056d547',
      /* Photon Momentum to the same module in 2e */
      '61a33ee4-2b3d-44b0-97cc-9d98d7d1ea94': '8a9207a8-c006-4ef7-b399-2960a5dcc23b',
      /* The Particle-Wave Duality to the same module in 2e */
      'f9779830-82c2-4db6-853d-b1530f7ea407': '0147c115-52e7-43ac-8117-2f285e76152b',
      /* The Wave Nature of Matter to the same module in 2e */
      '46d279bb-d45f-4e77-b0b7-ddf8da811b56': '96938a46-e4f4-473e-825a-61e8ccb53e09',
      /* Probability: The Heisenberg Uncertainty Principle to the same module in 2e */
      '804e89e6-b369-41e4-ba62-fd4a0f0412ce': 'd45b204f-4b3a-4c7a-9018-d091e9270579',
      /* The Particle-Wave Duality Reviewed to the same module in 2e */
      '9b0c944a-5226-4166-8872-d1b4bf8d05de': '3b84d6ab-1291-4e6a-8510-7772c0de699e',
      /* Discovery of the Atom to the same module in 2e */
      '01f8a8c3-62d7-4103-a1a0-a736c79c24ba': 'c0a608b1-2575-457f-8284-f5dea528053d',
      /* Discovery of the Parts of the Atom: Electrons and Nuclei to the same module in 2e */
      '3d2f7c60-784c-4d85-bf2c-f3372e7dfa86': '7ecc38ba-f855-43c4-bad7-50c40b70556d',
      /* Bohr’s Theory of the Hydrogen Atom to the same module in 2e */
      '3c5266a5-f611-4526-a101-f6328155a52b': '9a2ad24a-bdd0-4aa8-a99c-36ba54ec0f1f',
      /* X Rays: Atomic Origins and Applications to the same module in 2e */
      '22c1289d-0155-4447-aded-c985c767b61c': 'f7e016a3-3482-45f8-8b0e-857808864cfe',
      /* Applications of Atomic Excitations and De-Excitations to the same module in 2e */
      'caeea7c3-a008-4e93-959a-d979e08123f8': 'cfa19c4a-a833-400b-aaa8-a74479d13886',
      /* The Wave Nature of Matter Causes Quantization to the same module in 2e */
      '02dbae70-1c60-4144-8495-40108480434f': 'aedd88f0-3f74-4137-b2f1-67af8b4d7832',
      /* Patterns in Spectra Reveal More Quantization to the same module in 2e */
      'e3defadf-0cad-477a-b2ef-decb4b81b5fc': 'fea9523c-93cd-487c-bb4c-b2b367f5c279',
      /* Quantum Numbers and Rules to the same module in 2e */
      '71bdb2fc-6c60-44fb-a184-3490486931ca': 'c1f0576f-1366-45d2-8f18-a54b8b35c1c5',
      /* The Pauli Exclusion Principle to the same module in 2e */
      '5d022d8d-4961-4005-9b92-6a8d9faa8062': '506a4bfc-5522-4aa6-9b9c-0e7e2325dda0',
      /* Nuclear Radioactivity to the same module in 2e */
      'bed8d5ac-3c74-45bd-a60e-295cf2a8bb00': '7e35ad50-726e-4379-9152-c03fa312f746',
      /* Radiation Detection and Detectors to the same module in 2e */
      '0a5f9f4b-a0c4-4035-a6a1-9476d11df446': '030f371f-df0f-44f0-b7bf-1a8c8733ae0c',
      /* Substructure of the Nucleus to the same module in 2e */
      '9465bef4-1c54-4613-8a3e-c58dc6a44fe4': '00a834ca-b894-44cd-893c-efcb52b58f72',
      /* Nuclear Decay and Conservation Laws to the same module in 2e */
      '5529301b-e00a-4bb0-8e97-9efec34edf4c': '986a3705-7b56-4f11-9d04-25d028307f7a',
      /* Half-Life and Activity to the same module in 2e */
      '05459eed-9cdf-436a-939d-fa8a2c396afa': '074d2048-3b8a-4014-bf01-e0c56e219447',
      /* Binding Energy to the same module in 2e */
      '42135f52-f384-4b6f-bf27-63cfc0931271': 'e12b60f5-72df-401e-a1b1-7f13fd61eee0',
      /* Tunneling to the same module in 2e */
      '5f200319-d752-492c-916f-793d3fc3401e': 'f2f779e5-499b-4104-b62c-0ba44b60f13e',
      /* Medical Imaging and Diagnostics to the same module in 2e */
      '79ea9a77-e131-4b16-8f52-8b70c0a7993a': '82b2eff0-81a1-4672-b7ef-6f8bcc7c679b',
      /* Biological Effects of Ionizing Radiation to the same module in 2e */
      'af530f9b-cb3f-456f-b96c-dc31e2d9060a': '1c813e42-c4bd-406c-900e-82faf8875592',
      /* Therapeutic Uses of Ionizing Radiation to the same module in 2e */
      '40159b02-52a5-4490-83f8-54c61e997ca8': '96ed6849-22bb-4178-a008-6c09bd197dc6',
      /* Food Irradiation to the same module in 2e */
      'b66abbf4-e2be-4fc8-a229-f21d0084090b': 'ce99e7d4-0d3e-41dc-b7db-558908cdace5',
      /* Fusion to the same module in 2e */
      'ad1e6ae1-5a2e-428f-9ab9-efaafaf7e636': '6254177f-ecab-4cc5-8c45-d7de363ceef8',
      /* Fission to the same module in 2e */
      '363d4a1c-e5c4-4968-b57f-055d4b2a331d': '2c978a5d-0aa0-4a0e-b27f-675c2f726e51',
      /* Nuclear Weapons to the same module in 2e */
      '08e5adf8-37db-4c4b-82d9-e70acda148be': '97ac95af-81a6-44e4-8905-44f6de003165',
      /* The Yukawa Particle and the Heisenberg Uncertainty Principle Revisited to the same module in 2e */
      'd85b401c-83b6-48d7-9f7f-4622717b312a': '838d9f2b-d65b-44a7-b2d1-7897af0bc74f',
      /* The Four Basic Forces to the same module in 2e */
      'cc2a1c9e-3cbe-42a8-94b0-869ed7528153': '250aa14a-6759-48e1-8f7e-1b85911dd18e',
      /* Accelerators Create Matter from Energy to the same module in 2e */
      '0c76efab-951f-4cc0-8b85-afc11c8a829c': '6b2a5350-490f-4468-93d4-e201a6ba4c4a',
      /* Particles, Patterns, and Conservation Laws to the same module in 2e */
      'a6d9a6e0-b84d-4d7d-a00b-dc9ff0cf9a82': 'b83fad6e-cef4-424c-a84f-7004bedc527b',
      /* Quarks: Is That All There Is? to the same module in 2e */
      'e2c852b6-a97f-45bc-898a-229aa2f10c8f': '76529201-fc01-415e-be4d-f735e826206c',
      /* GUTs: The Unification of Forces to the same module in 2e */
      '041ef802-788d-4c41-b2fe-8b8a2c31c10f': '31294629-8e8b-4eb1-9780-3d48345b9d88',
      /* Cosmology and Particle Physics to the same module in 2e */
      '410dda92-e868-4881-9695-965f05ea2df5': '170e24c0-f6a0-428a-b8a3-ac313e996e19',
      /* General Relativity and Quantum Gravity to the same module in 2e */
      'eb8fde82-4d56-49f6-b929-565d235dcf42': 'e4078a6e-89d4-472a-bb01-8e299d7ba0aa',
      /* Superstrings to the same module in 2e */
      '21cfe45e-c400-4135-93d3-b0db912ac611': '8490a079-d21f-4e21-88f1-2a3f5211e372',
      /* Dark Matter and Closure to the same module in 2e */
      '0ba23adb-6aa6-4f2b-b4fd-f53ed334a846': '5669781b-773d-4868-bea5-5c3b06ea91af',
      /* Complexity and Chaos to the same module in 2e */
      'f302a0dc-2262-4e6d-848d-1417799b7829': 'e1447443-fcb6-4b55-b3fc-2bde086ff569',
      /* High-temperature Superconductors to the same module in 2e */
      '9d4d6832-4a84-4657-adcb-c24f90c35c40': '48360edb-736c-4f9f-9a40-1beef1ddd2c1',
      /* Some Questions We Know to Ask to the same module in 2e */
      '8234a940-ff8f-4feb-a06e-e78e2af2072e': 'ce83ccca-dae7-461b-a20f-b853471543b8',
    }],
  ],
} as CanonicalBookMap;
